/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DocumentEditContext } from "../../context/document-edit-context";
import { useSnackbar } from "hooks/useSnackbar";
import LabelledField from "components/labelled-field/index";
import { ButtonOutlined } from "components/page-components/buttons/button-outlined";
import { SVGIcons } from "cms/icons/svg-icons";
import { TabPanel } from "cms/images/image-selector/dialog-edit/panels/tab-panel";
import { useDocuments } from "cms/documents/hooks/use-document";
import { isArrayNotEmpty } from "utils/empty-exists";
import Config from "data/config";
import { Button } from "@mui/material";

const DocumentEditPlacementsPanel = () => {

    const { showSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { getPlacements } = useDocuments();
    const [placements, setPlacements] = useState([]);

    const { selectedDocument, localState, hasDocument, selectedDocEditTab } = useContext(DocumentEditContext);
    const { guid } = selectedDocument || {};
    const copyText = selectedDocument?.guid;

    useEffect(() => {
        const fetchPlacements = async (guid) => {
            const result = await getPlacements(guid);
            // const resource = result?.resource;
            const placements = result?.placements;
            setPlacements(placements);
        };
        fetchPlacements(guid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    const onCopyToClipbaord = () => {
        navigator.clipboard.writeText(copyText);
        showSnackbar("Copied to system clipboard");
    };

    return (
        <>
            <TabPanel
                value={selectedDocEditTab}
                index={2}
                style={{ height: "100%" }}
            >
                {hasDocument && (
                    <>
                        <LabelledField label="GUID" className="labelField">
                            <div className="form-id-area">
                                <p>{localState?.document?.guid}</p>
                                <ButtonOutlined
                                    className="copyButton"
                                    startIcon={<SVGIcons.common.Copy />}
                                    onClick={onCopyToClipbaord}
                                    label={t("commons.copyToClipBoard")}
                                />
                            </div>
                        </LabelledField>
                        <LabelledField
                            label="Webpages"
                            className="labelField"
                            style={{ height: "100%" }}
                        >
                            <div style={{
                                border: "1px solid #dfdfdf",
                                borderRadius: "8px",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflowY: "auto",
                                fontSize: "13px",
                                padding: "0 12px",
                            }}
                            >
                                {isArrayNotEmpty(placements) && placements.map((placement, index) => {
                                    const { webpage, title, path, placed_as } = placement;
                                    const editPage = () => {
                                        const path = `/composer/${webpage}`;
                                        window.open(path, "placements",);
                                    };
                                    return (
                                        <div
                                            key={`${webpage}${index}`}
                                            style={{ display: "flex", flexDirection: "row", width: "100%", borderBottom: "1px solid #dfdfdf" }}
                                        >
                                            <div
                                                style={{
                                                    padding: "16px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "80%",
                                                }}
                                            >
                                                <div>
                                                    <div style={{ fontWeight: "700" }}>
                                                        Title: {title}
                                                    </div>
                                                    <div style={{ color: "#bebebe" }}>
                                                        Placement Type: {placed_as}
                                                    </div>
                                                    <div>
                                                        Path: <a target='_new' href={`${Config.previewUrl}${path}`}>{path}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "20%",
                                                // border: '1px solid red',
                                            }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    size={"small"}
                                                    onClick={editPage}
                                                >Edit</Button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </LabelledField>
                    </>
                )}
            </TabPanel>
        </>
    );
};

export { DocumentEditPlacementsPanel };
